var _circle, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEllie(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#F3F3F3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 12C17.383 12 12 17.383 12 24V33.535L12.445 33.832C12.578 33.92 15.792 36 24 36C32.208 36 35.422 33.92 35.555 33.832L36 33.535V24C36 17.383 30.617 12 24 12ZM24 33C19.038 33 15 28.962 15 24C15 22.145 15.505 20.983 15.924 19.983C20.124 19.561 22.968 18.234 26.005 15.208C30.718 16.614 33 20.226 33 24C33 28.962 28.962 33 24 33Z",
    fill: "#706d6d"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 26C20.3284 26 21 25.3284 21 24.5C21 23.6716 20.3284 23 19.5 23C18.6716 23 18 23.6716 18 24.5C18 25.3284 18.6716 26 19.5 26Z",
    fill: "#706d6d"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 26C29.3284 26 30 25.3284 30 24.5C30 23.6716 29.3284 23 28.5 23C27.6716 23 27 23.6716 27 24.5C27 25.3284 27.6716 26 28.5 26Z",
    fill: "#706d6d"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllie);
export default __webpack_public_path__ + "static/media/ellie.8e9e7b662f432b11abcfce8a411e14bc.svg";
export { ForwardRef as ReactComponent };